export default {"src":"/_next/static/media/cell.965f1bc3.svg","height":300,"width":300};